/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M20 21H4M16 4C15.75 5.75 17.25 7.25 19 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.4999 3.49998L9.25327 10.7465C8.7867 11.2131 8.55341 11.4464 8.36373 11.7102C8.19533 11.9445 8.05276 12.1963 7.93853 12.4612C7.80985 12.7596 7.72984 13.0797 7.56981 13.7198L6.99976 16L9.27999 15.4299L9.28 15.4299C9.92011 15.2699 10.2402 15.1899 10.5386 15.0612C10.8035 14.947 11.0553 14.8044 11.2895 14.636C11.5534 14.4464 11.7867 14.2131 12.2532 13.7465L19.4998 6.49994L19.4999 6.4999C19.5795 6.4203 19.6193 6.38049 19.6513 6.34525C20.3447 5.58244 20.3447 4.41755 19.6513 3.65472C19.6193 3.61947 19.5795 3.57966 19.4999 3.50003C19.4202 3.4204 19.3804 3.38058 19.3452 3.34854C18.5823 2.6551 17.4174 2.65508 16.6546 3.3485C16.6193 3.38054 16.5795 3.42034 16.4999 3.49994L16.4999 3.49998Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M15.4999 4.5L9.25328 10.7465L9.25328 10.7465C8.78671 11.213 8.55342 11.4463 8.36373 11.7102C8.19533 11.9444 8.05276 12.1962 7.93853 12.4612C7.80985 12.7596 7.72984 13.0796 7.5698 13.7198L6.99976 16L9.27999 15.4299C9.92011 15.2699 10.2402 15.1899 10.5386 15.0612C10.8035 14.947 11.0553 14.8044 11.2895 14.636C11.5534 14.4463 11.7867 14.213 12.2532 13.7465L18.4998 7.5C18.4998 7.5 17 7 16.5 6.5C16 6 15.4999 4.5 15.4999 4.5Z"
				fill="currentColor"
			/>
			<path
				d="M19.9998 21H3.99976M15.9998 4C15.7498 5.75 17.2498 7.25 18.9998 7M6.99976 16L7.56981 13.7198C7.72984 13.0797 7.80985 12.7596 7.93853 12.4612C8.05276 12.1963 8.19533 11.9445 8.36373 11.7102C8.55341 11.4464 8.7867 11.2131 9.25327 10.7465L16.4999 3.49998C16.5795 3.42036 16.6193 3.38054 16.6546 3.3485C17.4174 2.65508 18.5823 2.6551 19.3452 3.34854C19.3804 3.38058 19.4202 3.4204 19.4999 3.50003V3.50003C19.5795 3.57966 19.6193 3.61947 19.6513 3.65472C20.3447 4.41755 20.3447 5.58244 19.6513 6.34525C19.6193 6.3805 19.5794 6.42031 19.4998 6.49994L12.2532 13.7465C11.7867 14.2131 11.5534 14.4464 11.2895 14.636C11.0553 14.8044 10.8035 14.947 10.5386 15.0612C10.2402 15.1899 9.9201 15.2699 9.27999 15.4299L6.99976 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.8499 2.79362C18.801 1.84014 17.1992 1.84011 16.1503 2.79356C16.1015 2.83793 16.0497 2.88978 15.9824 2.95712L15.9698 2.96969L8.72318 10.2162L8.67909 10.2603C8.25449 10.6848 7.98069 10.9585 7.75499 11.2725C7.55502 11.5507 7.38572 11.8497 7.25007 12.1643C7.09697 12.5193 7.00311 12.895 6.85756 13.4774L6.84245 13.5379L6.27239 15.8181C6.2085 16.0737 6.28338 16.3441 6.46967 16.5304C6.65596 16.7167 6.92632 16.7915 7.1819 16.7276L9.46213 16.1576L9.52265 16.1425C10.1051 15.9969 10.4807 15.9031 10.8358 15.75C11.1504 15.6143 11.4494 15.445 11.7276 15.2451C12.0415 15.0194 12.3152 14.7456 12.7397 14.321L12.7838 14.2769L20.0304 7.03031L20.0429 7.01779L20.0429 7.01778C20.1103 6.95044 20.1621 6.89859 20.2065 6.84977C21.16 5.80091 21.16 4.19918 20.2066 3.15029C20.1622 3.10151 20.1104 3.04969 20.0431 2.98241L20.043 2.98234L20.0304 2.96975L20.0179 2.95718L20.0178 2.95715C19.9505 2.88983 19.8987 2.83798 19.8499 2.79362ZM4 20.25C3.58579 20.25 3.25 20.5858 3.25 21C3.25 21.4143 3.58579 21.75 4 21.75H20C20.4142 21.75 20.75 21.4143 20.75 21C20.75 20.5858 20.4142 20.25 20 20.25H4Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 8.99976L19.4998 6.49994C19.5794 6.42031 19.6193 6.3805 19.6513 6.34525C20.3447 5.58244 20.3447 4.41755 19.6513 3.65472C19.6193 3.61947 19.5795 3.57966 19.4999 3.50003V3.50003C19.4202 3.4204 19.3804 3.38058 19.3452 3.34854C18.5823 2.6551 17.4174 2.65508 16.6546 3.3485C16.6193 3.38054 16.5795 3.42036 16.4999 3.49998L9.25327 10.7465C8.7867 11.2131 8.55341 11.4464 8.36373 11.7102C8.19533 11.9445 8.05276 12.1963 7.93853 12.4612C7.80985 12.7596 7.72984 13.0797 7.56981 13.7198L6.99976 16L9.27999 15.4299C9.9201 15.2699 10.2402 15.1899 10.5386 15.0612C10.8035 14.947 11.0553 14.8044 11.2895 14.636C11.5534 14.4464 11.7867 14.2131 12.2532 13.7465L14.4998 11.5M19.9998 21H16.9998M12.9998 21H3.99976M15.9998 4C15.7498 5.75 17.2498 7.25 18.9998 7"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M19.9998 21H3.99976M15.9998 4C15.7498 5.75 17.2498 7.25 18.9998 7M6.99976 16L7.56981 13.7198C7.72984 13.0797 7.80985 12.7596 7.93853 12.4612C8.05276 12.1963 8.19533 11.9445 8.36373 11.7102C8.55341 11.4464 8.7867 11.2131 9.25327 10.7465L16.4999 3.49998C16.5795 3.42036 16.6193 3.38054 16.6546 3.3485C17.4174 2.65508 18.5823 2.6551 19.3452 3.34854C19.3804 3.38058 19.4202 3.4204 19.4999 3.50003V3.50003C19.5795 3.57966 19.6193 3.61947 19.6513 3.65472C20.3447 4.41755 20.3447 5.58244 19.6513 6.34525C19.6193 6.3805 19.5794 6.42031 19.4998 6.49994L12.2532 13.7465C11.7867 14.2131 11.5534 14.4464 11.2895 14.636C11.0553 14.8044 10.8035 14.947 10.5386 15.0612C10.2402 15.1899 9.9201 15.2699 9.27999 15.4299L6.99976 16Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M20.0305 2.96971C18.9092 1.84837 17.0911 1.84834 15.9698 2.96965L8.5763 10.3631C8.10973 10.8296 7.87645 11.0629 7.68676 11.3268C7.51836 11.561 7.3758 11.8128 7.26156 12.0778C7.13289 12.3762 7.05288 12.6962 6.89284 13.3364L6.29262 15.7373C6.18596 16.1639 6.13262 16.3772 6.19085 16.5259C6.24167 16.6557 6.34434 16.7583 6.4741 16.8092C6.62278 16.8674 6.83611 16.8141 7.26276 16.7074L9.66368 16.1072C10.3038 15.9471 10.6239 15.8671 10.9223 15.7385C11.1872 15.6242 11.439 15.4817 11.6732 15.3133C11.9371 15.1236 12.1704 14.8903 12.6369 14.4237L20.0304 7.03027C21.1517 5.90898 21.1517 4.09102 20.0305 2.96971Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.25 21.0001C3.25 20.5859 3.58579 20.2501 4 20.2501H20C20.4142 20.2501 20.75 20.5859 20.75 21.0001C20.75 21.4143 20.4142 21.7501 20 21.7501H4C3.58579 21.7501 3.25 21.4143 3.25 21.0001Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
